export default __webpack_public_path__ + "static/media/n1.22f72b1a.png";